// noinspection DuplicatedCode

import {BubblesField, Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import {CheckBoxOutlineBlank, CheckBoxOutlined} from '@mui/icons-material';
import {InputAdornment} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React, {useCallback, useMemo} from 'react';
import {useFormContext} from 'react-hook-form';
import {useMaterialBubbles, useMaterialOptionBubbles} from '../../../../hooks';
import {currencySymbol} from '../../../../utilities';

const useStyles = makeStyles(() => ({
  hidden: {
    display: 'none'
  }
}));

const Fields = ({order, item = {}, prefix = '', showCommodity = false}) => {
  const classes = useStyles();
  const {setValue, /** @var {function(string): string} */watch} = useFormContext();

  const materials = useMaterialBubbles();
  const {formats, colours} = useMaterialOptionBubbles();

  const formatID = watch(`${prefixWithSeparator(prefix)}format_id`);
  const colourID = watch(`${prefixWithSeparator(prefix)}colour_id`);

  const priceTBCName = useMemo(() => `${prefixWithSeparator(prefix)}price_tbc`, [prefix]);
  const priceTBC = watch(priceTBCName);

  const handleReset = useCallback((subject) => {
    if (subject.material) {
      subject.material_id = subject.material.id;
    }
    subject.format_id = subject.format?.id;
    if (!subject.format_id) {
      if (subject.format?.name) {
        subject.format_id = 'O';
        subject.other_format = subject.format.name;
      }
    }
    subject.colour_id = subject.colour?.id;
    if (!subject.colour_id) {
      if (subject.colour?.name) {
        subject.colour_id = 'O';
        subject.other_colour = subject.colour.name;
      }
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={item}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Material',
          fields: [
            <BubblesField
              name="material_id"
              prefix={prefix}
              label="Material"
              bubbles={materials}
              rules={{required: 'Please select a material'}}
            />,
            <BubblesField
              name="format_id"
              prefix={prefix}
              label="Format"
              bubbles={formats}
            />,
            <div className={formatID === 'O' ? '' : classes.hidden}>
              <TextField
                name="other_format"
                prefix={prefix}
                label="Enter other format"
              />
            </div>,
            <BubblesField
              name="colour_id"
              prefix={prefix}
              label="Colour"
              bubbles={colours}
            />,
            <div className={colourID === 'O' ? '' : classes.hidden}>
              <TextField
                name="other_colour"
                prefix={prefix}
                label="Enter other colour"
              />
            </div>,
          ]
        },
        {
          title: 'Details',
          fields: [
            ...(showCommodity ? [
              <TextField
                name="commodity_code"
                prefix={prefix}
                label="Commodity Code"
              />
            ] : []),
            <TextField
              name="price"
              prefix={prefix}
              label="Price"
              rules={{required: 'Please enter a price'}}
              fieldProps={{
                InputProps: {
                  disabled: priceTBC === '1',
                  startAdornment: (
                    <InputAdornment position="start">
                      {currencySymbol(order.currency)}
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{cursor: 'pointer'}}
                      onClick={() => setValue(priceTBCName, priceTBC === '1' ? '0' : '1')}
                    >
                      <span>TBC?</span>{priceTBC === '1' ? <CheckBoxOutlined/> : <CheckBoxOutlineBlank/>}
                    </InputAdornment>
                  )
                }
              }}
            />,
            <TextField
              name="weight"
              prefix={prefix}
              label="Weight"
              fieldProps={{
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      MT
                    </InputAdornment>
                  )
                }
              }}
            />
          ]
        }
      ]}
    />
  );
};

export default Fields;
